module.exports = __webpack_public_path__ + "img/growth-img.bbf69a43.svg";